import { useState, useEffect } from "react";
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, CardFooter, Button} from "reactstrap";
import axios from 'axios'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Header from "components/Headers/Header.js";
import { format } from 'date-fns'; 
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link } from "react-router-dom";

function Profile() {

    const [loading, setLoading]=useState(true)
    const [user, setUser]=useState('')

    const [loadingsubmitdeveloperaccount, setLoadingsubmitdeveloperaccount]=useState(true)
    const [modaldeveloperaccount, setModaldeveloperaccount] = useState(false);

    const toggleModalDeveloperAccount = () => setModaldeveloperaccount(!modaldeveloperaccount);

    const [loadingsubmitinsuranceaccount, setLoadingsubmitinsuranceaccount]=useState(true)
    const [modalinsuranceaccount, setModalinsuranceaccount] = useState(false);

    const toggleModalInsuranceAccount = () => setModalinsuranceaccount(!modalinsuranceaccount);


    const token = useSelector((state) => state.userLogin.userInfo.token);

    ////////////
    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);
    ////////////

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/authentication/user-detail/`, config);
                
                setUser(response.data)

            } catch (error) {

            } finally {
                setLoading(false)
            }
        };

        fetchData(); 
    }, [token]);

    const SubmitDeveloperAccount = async() => {
        setLoadingsubmitdeveloperaccount(false);

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        };   
            
        try {
            await axios.get(`${process.env.REACT_APP_BACKEND_API}/authentication/abilate-developer-account/`, config);
            toggleModalDeveloperAccount(); // Open modal after successful submission
        } catch (error) {
            console.error(error); // Handle errors as needed
        } finally {
            setLoadingsubmitdeveloperaccount(true);
        }
    };

    const SubmitInsuranceAccount = async() => {

        setLoadingsubmitinsuranceaccount(false);

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        };   
            
        try {
            await axios.get(`${process.env.REACT_APP_BACKEND_API}/authentication/abilate-insurance-account/`, config);
            toggleModalInsuranceAccount(); // Open modal after successful submission
        } catch (error) {
            console.error(error); // Handle errors as needed
        } finally {
            setLoadingsubmitinsuranceaccount(true);
        }
    };  

    return (
        <div>
            <Header/>
            {loading ? (
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Spinner>
                                {t('Loading')}
                            </Spinner>
                        </Col>
                    </Row>
                </Container>
            ):(
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Card>
                                <CardHeader>
                                    <h3>{t('Profile')}</h3>
                                </CardHeader>
                                <CardBody>
                                    <h4>{t('Name')}: {user.first_name}</h4>
                                    <h4>{t('Last Name')}: {user.last_name}</h4>
                                    <h4>{t('Email')}: {user.email}</h4>
                                    <h4>{t('Date Joined')}: {format(new Date(user.date_joined), 'PPpp')}</h4>
                                    <h4>{t('Normal User?')} {user.is_normal_user ? (
                                                                    <FaCheckCircle color="green" />
                                                              ) : (
                                                                    <FaTimesCircle color="red" />
                                                              )}</h4>
                                    <h4>{t('Developer Account?')} {user.is_developer ? (
                                            <FaCheckCircle color="green" />
                                        ) : (
                                            <FaTimesCircle color="red" />
                                    )}</h4>
                                    <h4>{t('Agricultural Insurance Account?')} {user.is_insurance_profile ? (
                                            <FaCheckCircle color="green" />
                                        ) : (
                                            <FaTimesCircle color="red" />
                                    )}</h4>
                                </CardBody>
                                <CardFooter>
                                    <Row>
                                        {loadingsubmitdeveloperaccount ? (
                                            <>
                                                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="text-center mt-2">
                                                    <Button color="success" onClick={SubmitDeveloperAccount}>
                                                        {t('Ask to abilate the developer Mode')} <i className="fa-solid fa-code"></i>
                                                    </Button>
                                                </Col>
                                            </>
                                        ) : (
                                            <>
                                                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="text-center mt-2">
                                                    <Button color="success" disabled>
                                                        <Spinner size="sm">
                                                            {t('Sending your request...Loading...')}
                                                        </Spinner>
                                                        <span>
                                                            {' '}{t('Sending your request...Loading...')}
                                                        </span>
                                                    </Button>
                                                </Col>
                                            </>
                                        )}
                                        {loadingsubmitinsuranceaccount ? (
                                            <>
                                                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="text-center mt-2">
                                                    <Button color="info" onClick={SubmitInsuranceAccount}>
                                                        {t('Ask to abilate the insurance Mode')} <i className="fa-solid fa-shield"></i>
                                                    </Button>
                                                </Col>
                                            </>
                                        ) : (
                                            <>
                                                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="text-center mt-2">
                                                    <Button color="info" disabled>
                                                        <Spinner size="sm">
                                                            {t('Sending your request...Loading...')}
                                                        </Spinner>
                                                        <span>
                                                            {' '}{t('Sending your request...Loading...')}
                                                        </span>
                                                    </Button>
                                                </Col>
                                            </>
                                        )} 
                                        <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="text-center mt-2">
                                            <Link to="/">
                                                <Button color="primary">
                                                    {t('Go back')} <i className="fas fa-rotate-left"></i>
                                                </Button>
                                            </Link>
                                        </Col>                                       
                                    </Row>
                                </CardFooter>
                            </Card>
                            <Modal isOpen={modaldeveloperaccount} toggle={toggleModalDeveloperAccount}>
                                <ModalHeader toggle={toggleModalDeveloperAccount}>{t('Abilating your developer account')}</ModalHeader>
                                <ModalBody>
                                    <p>{t('A email has been sent to your email.') }</p>
                                    <p>{t('One operator will review your request, and send you a email as soon as possible to notify you that your account is now setted to be a developer account') }</p>
                                </ModalBody>
                            </Modal>
                            <Modal isOpen={modalinsuranceaccount} toggle={toggleModalInsuranceAccount}>
                                <ModalHeader toggle={toggleModalInsuranceAccount}>{t('Abilating your insurance account')}</ModalHeader>
                                <ModalBody>
                                    <p>{t('A email has been sent to your email.') }</p>
                                    <p>{t('One operator will review your request, and send you a email as soon as possible to notify you that your account is now setted to be a insurance account') }</p>
                                </ModalBody>
                            </Modal>
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    )
}

export default Profile
